export const JOB_ROLES = {
  OTHER: 18,
};
